import { useState } from 'react';
import { Stack } from '@zurich/ui/atoms';
import { ToggleButtonGroup } from '@zurich/ui/molecules';
import { FAQ } from './Tips/FAQ';
import { PhotoTips } from './Tips/PhotoTips';

export function PhotosOverview() {
  const [selectedOption, setSelectedOption] = useState<
    'photo-tips' | 'common-questions'
  >('photo-tips');

  return (
    <Stack alignItems="center" rowGap={1}>
      <ToggleButtonGroup
        maxWidth="fit-content"
        data={[
          {
            value: 'photo-tips',
            translationKey: 'vsga:photosOverview.photoTips',
          },
          {
            value: 'common-questions',
            translationKey: 'vsga:photosOverview.faq',
          },
        ]}
        selectedOption={selectedOption}
        handleSelectedOption={setSelectedOption}
      />
      {selectedOption === 'photo-tips' ? <PhotoTips /> : <FAQ />}
    </Stack>
  );
}
